export enum remoteDeviceKeyLength {
    Single = 1,
    Double = 2,
}

export namespace remoteDeviceKeyLength {
    export function values() {
        return Object.keys(remoteDeviceKeyLength).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}
